/**
 * React Starter Kit (https://www.reactstarterkit.com/)
 *
 * Copyright © 2014-2016 Kriasoft, LLC. All rights reserved.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.txt file in the root directory of this source tree.
 */

import React, { Component, PropTypes } from 'react';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import Helmet from 'react-helmet';
import Sidebar from '../../components/SidebarBlogue';
import s from './singleBlogue.css';
import Social from '../../components/ShareSocial';
import { Link } from 'react-router';
import { ShareButtons, ShareCounts, generateShareIcon } from 'react-share';
import { Facebook } from 'react-sharingbuttons';
import share from 'share-my-url';
import $ from 'jquery';


const { FacebookShareButton, LinkedinShareButton } = ShareButtons;

const FacebookIcon = generateShareIcon('facebook');
const LinkedinIcon = generateShareIcon('linkedin');

@withStyles(s)
export default class singleBlogue extends Component {

    constructor(props) {
        super(props);

        this.state = {
            posts: [],
            post: [],
            url: this.props.location.pathname,
            slug: this.props.location.pathname.split("/").slice(-1).pop(),
            categories: [],
            social: [],
            loader: true,
        };

        this.FindPost = this.FindPost.bind(this);
        
    }

    componentDidMount() {

        this.GetPosts();
    }

    FindPost(item){
        return item.slug === this.state.slug;
    }

    async GetPosts() {
        const resp = await fetch('/graphql', {
            method: 'post',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({
                query: '{posts{id, slug, title, titlePost, content, excerpt, thumbnail, categories{id, slug, name}, date, authorName, authorAvatar, lienSociaux, ogImage}}',
            }),
            credentials: 'include',
        });
        const { data } = await resp.json();
        if (!data || !data.posts) throw new Error('Erreur sur le chargement des posts !');

        if(data){
            this.setState({ loader: false })
        }

        this.setState({ posts: data.posts });

        this.setState({ post: this.state.posts.find(this.FindPost) });

        this.setState({ categories: this.state.post.categories });

    }

    render() {

        const appear = this.state.loader ? 'appear' : '';
        var background = {
            backgroundColor: '#00bf43'
        }
        
        const shareUrl = "http://agenceprolifik.com"+this.state.url;
        const title = 'Blogue - ' + this.state.post.titlePost;
        const titlePost = this.state.post.titlePost;
        const thumbnail = this.state.post.thumbnail;
        const categories = this.state.categories;
        const postTitle = <span className={`titreArticle`} dangerouslySetInnerHTML={{ __html: this.state.post.title }} />;
        const authorAvator = <div dangerouslySetInnerHTML={{ __html: this.state.post.authorAvatar }} />;
        const authorName = this.state.post.authorName;
        const postDate = this.state.post.date;
        const postContent = <div dangerouslySetInnerHTML={{ __html: this.state.post.content }} />
        const excerpt = this.state.post.excerpt;
        const lienSociaux = <div dangerouslySetInnerHTML={{ __html: this.state.post.lienSociaux }} />

        const ogTitle = this.state.post.titlePost;
        const ogDesc = this.state.post.excerpt;
        const ogImage = this.state.post.ogImage;

        
       
        
        return (
            <div className={s.root}>

                <Helmet 
                    title={title} 
                    meta={[
                    {"name": "description", "content": "Agence Web, Article, Blogue, Marketing Web, Developpement Web, Stratégie Web"},
                    {"property": "og:title", "content": ogTitle}, 
                    {"property": "og:description", "content": ogDesc},
                    {"property": "og:image", "content": ogImage},
                    {"property": "og:image:width", "content": "1200"},
                    {"property": "og:image:height", "content": "630"},
                    {"property": "og:site_name", "content": "Blogue Agence Prolifik"},
                    {"property": "og:site", "content": 'agenceprolifik.ca' }]} />

                <div className={`spinner ${appear}`} style={background} ></div>
                <div id="blogue" className={`blogue`}>
                    <div className="bgHeader"></div>
                    <main role="main">
                        <div className={`container`}>
                            <h1 className={`titrePage`}><Link to={`/blogue`}>Blogue</Link></h1>
                            <div className={`col-md-8`}>
                               <div className={`wrapArticle`}>
                                    <div className={`article`}>
                                        <div className={`boxArticle`}>
                                            <div className={`content`}>
                                                <div className={`thumbBlogue`}>
                                                    <img src={thumbnail} alt="Image article" />
                                                    <div className={`wrapCatArticle`}>
                                                        {categories.map((cat, index) => (
                                                            <span key={index} className={`catArticle`}>
                                                                <Link to={`/blogue/categorie/${cat.slug}`}>{cat.name}</Link>
                                                            </span>
                                                        ))}
                                                    </div>
                                                </div>
                                                <div className={`auteurArticle`}>
                                                    <div className={`thumbAuteur`}>{authorAvator}</div>
                                                    <div className={`wrapDateNom`}>
                                                        <span className={`nomAuteur`}>{authorName}</span>
                                                        <span className={`dateArticle`}>{postDate}</span>
                                                    </div>
                                                    <div className={`socialAuthor`}>
                                                        {lienSociaux}
                                                    </div>
                                                </div>
                                                <div className={`wrapShare`}>
                                                    <div className={`btnShare`}>
                                                        <i className={`fa fa-share-alt iconShare`}></i>
                                                        <span className={`titreSocialIcon`}>Partager</span>
                                                    </div>
                                                    <div className={`blocSocialIcon`}>
                                                        <i className={`fa fa-share-alt iconShare`}></i>
                                                        <span className={`titreSocialIcon`}>Partager</span>
                                                        <div className={`wrapSocialIcon`}>
                                                            <div className={`iconSocial`}>
                                                                <FacebookShareButton
                                                                    url={shareUrl}
                                                                    title={title}
                                                                    description={excerpt}
                                                                    picture={ogImage}
                                                                    className={`FacebookShare`}>
                                                                    <FacebookIcon size={32} round={false} />
                                                                </FacebookShareButton>
                                                            </div>
                                                            <div className={`iconSocial`}>
                                                                <LinkedinShareButton
                                                                    url={shareUrl}
                                                                    title={title}
                                                                    description={excerpt}
                                                                    className={`linkedinShare`}>
                                                                    <LinkedinIcon size={32} round={false} />
                                                                </LinkedinShareButton>
                                                            </div>
                                                        </div>
                                                    </div>  
                                                </div>
                                                {postTitle}
                                                <div className={`contentArticle`}>
                                                    {postContent}
                                                </div>
                                                <div className={`wrapShare bottom`}>
                                                    <div className={`btnShare`}>
                                                        <i className={`fa fa-share-alt iconShare`}></i>
                                                        <span className={`titreSocialIcon`}>Partager</span>
                                                    </div>
                                                    <div className={`blocSocialIcon`}>
                                                        <i className={`fa fa-share-alt iconShare`}></i>
                                                        <span className={`titreSocialIcon`}>Partager</span>
                                                        <div className={`wrapSocialIcon`}>
                                                            <div className={`iconSocial`}>
                                                                <FacebookShareButton
                                                                    url={shareUrl}
                                                                    title={title}
                                                                    description={excerpt}
                                                                    picture={ogImage}
                                                                    className={`FacebookShare`}>
                                                                    <FacebookIcon size={32} round={false} />
                                                                </FacebookShareButton>
                                                            </div>
                                                            <div className={`iconSocial`}>
                                                                <LinkedinShareButton
                                                                    url={shareUrl}
                                                                    title={title}
                                                                    description={excerpt}
                                                                    className={`linkedinShare`}>
                                                                    <LinkedinIcon size={32} round={false} />
                                                                </LinkedinShareButton>
                                                            </div>
                                                        </div>
                                                    </div>  
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className={`col-md-4`}>
                                <div className={`sidebar`}>
                                    <div className={`content`}>
                                        <Sidebar />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </main>
                </div>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./containers/singleBlogue/singleBlogue.js